import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { Validators, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DeleteDialogLibraryComponent, DeleteDialogLibraryModule } from 'delete-dialog-library';
import { MarkDirtyFormAction } from 'dirty-check-store';
import * as i2 from 'primeng/dynamicdialog';
import { DialogService } from 'primeng/dynamicdialog';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import * as i4 from '@ngrx/store';
import * as i5 from 'primeng/dropdown';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/button';
import * as i8 from 'primeng/inputtext';
import * as i9 from 'primeng/card';
import * as i10 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';

class JobDutiesService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getJobRoles(companyId) {
        return this.httpClient.get(`/company/${companyId}/masterData/jobRole`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getIOSMapping(visatype, caseType, caseId, positionId, dutyId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/position/${positionId}/duty/${dutyId}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getJobRolesDuties(visatype, companyId, jobTitle) {
        return this.httpClient.get(`/${visatype}/company/${companyId}/position/${jobTitle}`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
}
JobDutiesService.ɵfac = function JobDutiesService_Factory(t) { return new (t || JobDutiesService)(i0.ɵɵinject(i1.HttpClient)); };
JobDutiesService.ɵprov = i0.ɵɵdefineInjectable({ token: JobDutiesService, factory: JobDutiesService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function JobDutiesComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵelementStart(1, "label", 4);
    i0.ɵɵtext(2, " Specify");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "input", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("readonly", ctx_r0.disabledControls);
} }
function JobDutiesComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "button", 20);
    i0.ɵɵlistener("click", function JobDutiesComponent_div_16_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r3 = i0.ɵɵnextContext(); return ctx_r3.handleOnsaveJobRoleOrPopulateDuties(); });
    i0.ɵɵtext(2, " Populate Job Duties ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r1.disabledControls || !ctx_r1.selectedJobPosition ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r1.disabledControls || !ctx_r1.selectedJobPosition);
} }
function JobDutiesComponent_p_card_28_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtext(1, "Sub-Duty ");
    i0.ɵɵelementEnd();
} }
function JobDutiesComponent_p_card_28_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 38);
    i0.ɵɵelementStart(5, "button", 39);
    i0.ɵɵlistener("click", function JobDutiesComponent_p_card_28_div_15_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r13); const subJobDutyIndex_r10 = ctx.index; const dutyIndex_r6 = i0.ɵɵnextContext().index; const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.subDutiesDelete(dutyIndex_r6, subJobDutyIndex_r10); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const dutyDescription_r9 = ctx.$implicit;
    const subJobDutyIndex_r10 = ctx.index;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", subJobDutyIndex_r10);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", dutyDescription_r9.value.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r8.disabledControls);
} }
function JobDutiesComponent_p_card_28_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-card", 21);
    i0.ɵɵelementStart(1, "div", 22);
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵelementStart(3, "span", 24);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 25);
    i0.ɵɵelementStart(6, "div", 26);
    i0.ɵɵelementStart(7, "div", 27);
    i0.ɵɵtext(8, " Duty ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 28);
    i0.ɵɵelementStart(10, "button", 29);
    i0.ɵɵlistener("click", function JobDutiesComponent_p_card_28_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r15); const duty_r5 = ctx.$implicit; const dutyIndex_r6 = ctx.index; const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.dutiesDelete(duty_r5, dutyIndex_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "button", 30);
    i0.ɵɵlistener("click", function JobDutiesComponent_p_card_28_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r15); const duty_r5 = ctx.$implicit; const dutyIndex_r6 = ctx.index; const ctx_r16 = i0.ɵɵnextContext(); return ctx_r16.handleEdit(duty_r5, dutyIndex_r6); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 31);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, JobDutiesComponent_p_card_28_div_14_Template, 2, 0, "div", 32);
    i0.ɵɵtemplate(15, JobDutiesComponent_p_card_28_div_15_Template, 6, 3, "div", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const duty_r5 = ctx.$implicit;
    const dutyIndex_r6 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroupName", dutyIndex_r6);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(dutyIndex_r6 + 1);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r2.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", duty_r5.value.name, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.getSubDutiesList(dutyIndex_r6).length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.getSubDutiesList(dutyIndex_r6));
} }
const deleteDialogConfigurations = {
    width: '30%',
    closeOnEscape: false,
    closable: false,
    showHeader: false,
    contentStyle: { "z-index": "1001" }
};
class JobDutiesComponent {
    constructor(fb, dialogService, apiService, parentFor, store) {
        this.fb = fb;
        this.dialogService = dialogService;
        this.apiService = apiService;
        this.parentFor = parentFor;
        this.store = store;
        this.deleteDuty = new EventEmitter();
        this.deleteAllDutie = new EventEmitter();
        this.deleteSubDuty = new EventEmitter();
        this.addUpdateDuty = new EventEmitter();
        this.observableSubscription$ = new Subject();
        this.disabledControls = false;
        this.jobRoleOptions = [];
        this.selectedJobPosition = '';
        this.otherJobPosition = '';
    }
    ngOnInit() {
        this.jobDutiesForm = this.fb.group({
            otherJobPosition: [],
            jobRole: ['', [Validators.required]],
            duties: this.fb.array([])
        });
        this.form = this.parentFor.form;
        this.form.addControl('jobDutiesForm', this.jobDutiesForm);
        this.getJobRoles();
    }
    handleOnsaveJobRoleOrPopulateDuties() {
        const input = { selectedJobPosition: this.jobDutiesForm.get('jobRole').value, customPositionTitle: this.jobDutiesForm.get('otherJobPosition').value };
        const overlppingReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                deleteMessage: 'Do you wish to populate duties & sub duties? This will override any existing duties'
            } }));
        overlppingReconfirmDialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && this.jobDutiesForm.value && this.jobDutiesForm.value.id) {
                this.apiService.getIOSMapping(this.primaryData.visatype, this.primaryData.caseType, this.primaryData.caseId, this.jobDutiesForm.value.id, 0).subscribe((response) => {
                    if (response && response.data && response.data['isAnyDependency']) {
                        const deleteReconfirmDialogRef = this.dialogService.open(DeleteDialogLibraryComponent, Object.assign(Object.assign({}, deleteDialogConfigurations), { data: {
                                deleteMessage: 'Job duties cannot be populated as Itinerary of Services mapping exists with the job duties. Do you want continue with the deletion of Itinerary of Services mapping?'
                            } }));
                        deleteReconfirmDialogRef.onClose
                            .pipe(takeUntil(this.observableSubscription$))
                            .subscribe((response) => {
                            if (response) {
                                this.jobDutiesForm.controls['jobDutyForceDelete'].setValue(true);
                                this.populateJobDuties(input);
                            }
                        });
                    }
                    else {
                        this.populateJobDuties(input);
                    }
                });
            }
            else {
                // if there is no position id exists. no need to check ios mapping exists
                this.populateJobDuties(input);
            }
        });
    }
    populateJobDuties(input) {
        this.jobDutiesForm.controls['duties'].clear();
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
        this.apiService.getJobRolesDuties(this.primaryData.visatype, this.primaryData.companyId, input.selectedJobPosition).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                response.data.forEach(element => {
                    element['id'] = null;
                    element.subJobDuty.forEach(subJobDuty => {
                        subJobDuty['id'] = null;
                    });
                    this.jobDutiesForm.controls['duties'].push(this.buildDutyList(element));
                });
            }
        });
    }
    buildDutyList(item) {
        let subJobDuty = [];
        if (item.subJobDuty && item.subJobDuty.length > 0) {
            item.subJobDuty.forEach(element => {
                subJobDuty.push(this.buildSubDutyList(element));
            });
        }
        return this.fb.group({
            'id': item.id,
            'name': item.name,
            'subJobDuty': this.fb.array(subJobDuty)
        });
    }
    buildSubDutyList(item) {
        return this.fb.group({
            'id': item.id,
            'name': item.name
        });
    }
    getJobRoles() {
        this.apiService.getJobRoles(this.primaryData.companyId).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.jobRoleOptions = response.data;
                this.selectedJobPosition = this.jobDutiesForm.get('jobRole').value === 'Other' ? 'Other' : this.jobDutiesForm.get('jobRole').value;
                this.selectedJobPosition = this.jobDuties.get('jobRole').value === 'Other' ? 'Other' : this.jobDuties.get('jobRole').value;
            }
        });
    }
    setPositionTitle({ value }) {
        if (value !== 'Other') {
            this.jobDutiesForm.controls['otherJobPosition'].setValue('');
        }
        this.selectedJobPosition = value;
    }
    saveJobRoleOrPopulateDuties() {
        // this.handleOnsaveJobRoleOrPopulateDuties();
    }
    get dutyList() {
        return this.jobDutiesForm.controls['duties'].controls;
    }
    getSubDutiesList(dutyIndex) {
        return this.jobDutiesForm.controls['duties'].controls[dutyIndex].get('subJobDuty').controls;
    }
    addDuty(duty = null, type = 'ADD', dutyIndex = null) {
        this.dialogRef = this.dialogService.open(AddDutyComponent, {
            header: 'Add Duty and Sub-duties',
            data: {
                duties: {
                    name: duty && duty.name ? duty.name : '',
                    id: duty && duty.id ? duty.id : null,
                    subJobDuty: duty && duty.subJobDuty ? duty.subJobDuty : []
                },
                type: type,
                dutyIndex: dutyIndex
            },
            width: '70%',
            contentStyle: { "max-height": "500px", "overflow": "auto" },
            baseZIndex: 2000
        });
        this.dialogRef.onClose
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.addUpdateDuty.emit(response);
        });
    }
    deleteAllDuties() {
        this.deleteAllDutie.emit();
    }
    handleEdit(duty, dutyIndex) {
        this.addDuty(duty.value, 'UPDATE', dutyIndex);
    }
    dutiesDelete(duty, i) {
        this.deleteDuty.emit({ duty: duty, dutyIndex: i });
    }
    subDutiesDelete(dutyIndex, subJobDutyIndex) {
        this.deleteSubDuty.emit({ dutyIndex: dutyIndex, subJobDutyIndex: subJobDutyIndex });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
JobDutiesComponent.ɵfac = function JobDutiesComponent_Factory(t) { return new (t || JobDutiesComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.DialogService), i0.ɵɵdirectiveInject(JobDutiesService), i0.ɵɵdirectiveInject(i1$1.FormGroupDirective), i0.ɵɵdirectiveInject(i4.Store)); };
JobDutiesComponent.ɵcmp = i0.ɵɵdefineComponent({ type: JobDutiesComponent, selectors: [["job-duties"]], inputs: { primaryData: "primaryData", disabledControls: "disabledControls" }, outputs: { deleteDuty: "deleteDuty", deleteAllDutie: "deleteAllDutie", deleteSubDuty: "deleteSubDuty", addUpdateDuty: "addUpdateDuty" }, features: [i0.ɵɵProvidersFeature([DialogService], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 29, vars: 9, consts: [["formGroupName", "jobDutiesForm"], [1, "row", "col-md-12", "pt-4", "duties-header"], [1, "row"], [1, "col-md-6", "processing-dropdown"], [1, "label-cls"], ["id", "jobRolesId", "appendTo", "body", "optionLabel", "jobTitle", "optionValue", "jobTitle", "formControlName", "jobRole", "placeholder", "select", 3, "options", "filter", "disabled"], ["for", "pl-0", 1, "mb-0", "label-cls"], ["class", "col-md-3", 4, "ngIf"], ["class", "col-md-3 p-0 mt-4", 4, "ngIf"], [1, "row", "col-md-12", "mt-2", "pt-2", "d-flex", "align-items-center", "duties-header"], [1, "col-6", "p-0"], [1, "col-3"], [1, "pull-right"], ["type", "button", "pButton", "", "label", "Add New Duty", 1, "btn", "p-button-primary", 3, "disabled", "click"], ["type", "button", "pButton", "", "label", "Delete all duties", "icon", "pi pi-trash", "iconPos", "right", 1, "btn", "p-button-secondary", "delete-btn", "d-flex", "align-items-center", 3, "disabled", "click"], ["formArrayName", "duties", 1, "row", "mt-2", "col-md-12", "pb-5"], ["class", "my-1 col-md-12 duty-card", 4, "ngFor", "ngForOf"], [1, "col-md-3"], ["id", "otherJobPosition", "formControlName", "otherJobPosition", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [1, "col-md-3", "p-0", "mt-4"], ["type", "button", "pButton", "", 3, "ngClass", "disabled", "click"], [1, "my-1", "col-md-12", "duty-card"], [1, "row", "mt-2", 3, "formGroupName"], [1, "col-md-1", "mt-3", "text-center"], [1, "duty-list"], [1, "col-md-11", "pl-0"], [1, "row", "col-md-12", "duty-title", "d-flex", "align-items-center"], [1, "col-md-10", "pr-0", "pl-0", 2, "font-weight", "600"], [1, "col-md-2", "pr-0", "pl-0"], ["type", "button", "pButton", "", "pTooltip", "Delete", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], ["type", "button", "pButton", "", "pTooltip", "Edit", "icon", "pi pi-pencil", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"], [1, "row", "col-md-12", "duty-txt", 2, "font-size", "14px"], ["class", "row col-md-12 duty-title", "style", "font-size: 13px;font-weight: 600;", 4, "ngIf"], ["class", "row col-md-12 p-0", "formArrayName", "subJobDuty", 4, "ngFor", "ngForOf"], [1, "row", "col-md-12", "duty-title", 2, "font-size", "13px", "font-weight", "600"], ["formArrayName", "subJobDuty", 1, "row", "col-md-12", "p-0"], [1, "row", "col-md-12", "duty-txt", 3, "formGroupName"], [1, "col-md-11", "p-0", 2, "font-size", "14px"], [1, "col-md-1", "p-0"], ["pButton", "", "type", "button", "pTooltip", "Delete", "icon", "pi pi-trash", 1, "p-button-rounded", "p-button-text", "pull-right", 3, "disabled", "click"]], template: function JobDutiesComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h5");
        i0.ɵɵtext(3, "List Of Duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵelementStart(6, "label", 4);
        i0.ɵɵtext(7, " Select the Job Position?");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(8, "p-dropdown", 5);
        i0.ɵɵelementStart(9, "label", 6);
        i0.ɵɵelementStart(10, "b");
        i0.ɵɵtext(11, "Note");
        i0.ɵɵelementEnd();
        i0.ɵɵtext(12, " : ");
        i0.ɵɵelementStart(13, "span");
        i0.ɵɵtext(14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(15, JobDutiesComponent_div_15_Template, 4, 1, "div", 7);
        i0.ɵɵtemplate(16, JobDutiesComponent_div_16_Template, 3, 2, "div", 8);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 9);
        i0.ɵɵelementStart(18, "div", 10);
        i0.ɵɵelementStart(19, "h5");
        i0.ɵɵtext(20, " Added Duties & Sub-duties");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "div", 11);
        i0.ɵɵelementStart(22, "div", 12);
        i0.ɵɵelementStart(23, "button", 13);
        i0.ɵɵlistener("click", function JobDutiesComponent_Template_button_click_23_listener() { return ctx.addDuty(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(24, "div", 11);
        i0.ɵɵelementStart(25, "div", 12);
        i0.ɵɵelementStart(26, "button", 14);
        i0.ɵɵlistener("click", function JobDutiesComponent_Template_button_click_26_listener() { return ctx.deleteAllDuties(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(27, "div", 15);
        i0.ɵɵtemplate(28, JobDutiesComponent_p_card_28_Template, 16, 7, "p-card", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("options", ctx.jobRoleOptions)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(6);
        i0.ɵɵtextInterpolate1(" ", ctx.selectedJobPosition === "Other" ? "Please specify the job position" : "After selecting Job Position, Please click on the Populate Job Duties button to get the default List of Duties", "");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedJobPosition === "Other");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedJobPosition !== "Other");
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.dutyList);
    } }, directives: [i1$1.NgControlStatusGroup, i1$1.FormGroupName, i5.Dropdown, i1$1.NgControlStatus, i1$1.FormControlName, i6.NgIf, i7.ButtonDirective, i1$1.FormArrayName, i6.NgForOf, i1$1.DefaultValueAccessor, i8.InputText, i6.NgClass, i9.Card, i10.Tooltip], styles: [".label-cls[_ngcontent-%COMP%]{color:#626262;font-size:14px}.readOnly-label[_ngcontent-%COMP%]{width:100%;font-size:16px;color:#4a4a4a;padding-top:3px;font-weight:500}.sub-title[_ngcontent-%COMP%]{color:#3d3d63;font-size:16px;font-weight:700}.duty-title[_ngcontent-%COMP%]{background-color:#eff6ff;margin-bottom:0}.duty-title[_ngcontent-%COMP%], .duty-txt[_ngcontent-%COMP%]{padding:10px;border:1px solid #b0b0b0}.delete-btn[_ngcontent-%COMP%]{display:inline-flex;padding:10px!important}.btn-outline-secondary[_ngcontent-%COMP%]{border:1px solid #19a0da!important;background:#fff;height:43px;color:#19a0da;text-transform:uppercase;padding:0 17px!important;font-size:18px!important}.btn-outline-secondary.disabled[_ngcontent-%COMP%], .btn-outline-secondary[_ngcontent-%COMP%]:disabled{opacity:.65!important;border-color:#6c757d!important;color:#6c757d;background-color:transparent}.duties-header[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{color:#626262;font-size:18px;font-weight:700}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.mark-btn[_ngcontent-%COMP%]{background-color:#fff;color:#a2a2a2;font-size:14px;text-transform:uppercase;border:1px solid #a2a2a2;border-radius:8px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesComponent, [{
        type: Component,
        args: [{
                selector: 'job-duties',
                templateUrl: 'job-duties.component.html',
                styleUrls: ['job-duties.component.scss'],
                providers: [DialogService],
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ]
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.DialogService }, { type: JobDutiesService }, { type: i1$1.FormGroupDirective }, { type: i4.Store }]; }, { primaryData: [{
            type: Input
        }], deleteDuty: [{
            type: Output
        }], deleteAllDutie: [{
            type: Output
        }], deleteSubDuty: [{
            type: Output
        }], addUpdateDuty: [{
            type: Output
        }], disabledControls: [{
            type: Input
        }] }); })();
class AddDutyComponent {
    constructor(dutiesFormBuilder, config, ref) {
        this.dutiesFormBuilder = dutiesFormBuilder;
        this.config = config;
        this.ref = ref;
        this.resetForm();
    }
    ngOnInit() {
        this.dutiesForm.patchValue(this.config.data.duties);
        this.dutiesForm.get('subJobDuty').clear();
        this.config.data['duties'].subJobDuty.forEach((subDutyItem) => {
            this.dutiesForm.get('subJobDuty').push(this.createSubDuty(subDutyItem));
        });
    }
    createSubDuty(response) {
        return this.dutiesFormBuilder.group({
            id: response && response.id ? response.id : null,
            name: response && response.name ? response.name : null
        });
    }
    get subDutiesList() {
        return this.dutiesForm.get('subJobDuty').controls;
    }
    addSubDuty() {
        this.dutiesForm.get('subJobDuty').push(this.createSubDuty({}));
    }
    resetForm() {
        this.dutiesForm = this.dutiesFormBuilder.group({
            name: '',
            id: null,
            subJobDuty: this.dutiesFormBuilder.array([{
                    name: this.createSubDuty(null)
                }])
        });
    }
    handleClose() {
        this.ref.close();
    }
    appendDutyList() {
        this.ref.close({ type: this.config.data['type'], data: this.dutiesForm.value, dutyIndex: this.config.data['dutyIndex'] });
    }
}
AddDutyComponent.ɵfac = function AddDutyComponent_Factory(t) { return new (t || AddDutyComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.DynamicDialogConfig), i0.ɵɵdirectiveInject(i2.DynamicDialogRef)); };
AddDutyComponent.ɵcmp = i0.ɵɵdefineComponent({ type: AddDutyComponent, selectors: [["add-duty-dialog"]], decls: 0, vars: 0, template: function AddDutyComponent_Template(rf, ctx) { }, encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddDutyComponent, [{
        type: Component,
        args: [{
                selector: 'add-duty-dialog',
                templateUrl: 'new-duty.dialog.html'
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.DynamicDialogConfig }, { type: i2.DynamicDialogRef }]; }, null); })();

class JobDutiesModule {
}
JobDutiesModule.ɵfac = function JobDutiesModule_Factory(t) { return new (t || JobDutiesModule)(); };
JobDutiesModule.ɵmod = i0.ɵɵdefineNgModule({ type: JobDutiesModule });
JobDutiesModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            DeleteDialogLibraryModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(JobDutiesModule, { declarations: [JobDutiesComponent, AddDutyComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        DeleteDialogLibraryModule], exports: [JobDutiesComponent, AddDutyComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(JobDutiesModule, [{
        type: NgModule,
        args: [{
                declarations: [JobDutiesComponent, AddDutyComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    DeleteDialogLibraryModule
                ],
                exports: [JobDutiesComponent, AddDutyComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of job-duties
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddDutyComponent, JobDutiesComponent, JobDutiesModule, JobDutiesService, deleteDialogConfigurations };
//# sourceMappingURL=job-duties.js.map
